var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerifiedBoxVerifiedIcon = function SvgVerifiedBoxVerifiedIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5306 4.86074C11.5306 6.81876 9.9607 8.38878 8.0013 8.38878C6.04257 8.38878 4.47198 6.81876 4.47198 4.86074C4.47198 2.90272 6.04257 1.33337 8.0013 1.33337C9.9607 1.33337 11.5306 2.90272 11.5306 4.86074ZM8.0013 14.6667C5.10955 14.6667 2.66797 14.1967 2.66797 12.3834C2.66797 10.5693 5.12489 10.116 8.0013 10.116C10.8937 10.116 13.3346 10.586 13.3346 12.3994C13.3346 14.2134 10.8777 14.6667 8.0013 14.6667Z",
    fill: "#10C001"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerifiedBoxVerifiedIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "verifiedBoxVerifiedIcon.de32f40721930a3c87f2d05a3750db73.svg";